export const MembershipFeatureKey = 'membership';
